import React from 'react';
import _ from 'lodash';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import {QueueTable} from '../../../components/Tables/Queue';
import useStyles from '../../styles';

const Choose = ({isBusy, chooseData, action, setPath}) => {

  const classes = useStyles();

  return <Grid container spacing={1}>
    <Grid item xs={12}>
      <Typography className={classes.text}>
        {'Mapeamento Frete - Veículo'}
      </Typography>
    </Grid>
    <Grid item xs={12}>
      <QueueTable
        data={chooseData}
        {...{isBusy}}
      />
    </Grid>
    <Grid container xs={12} justify='space-around' align='center'>
    {
      !isBusy &&
        <>
          {
            !_.isEmpty(chooseData) &&
              <Grid item>
                <Button color='primary' onClick={action}>
                  Aceitar
                </Button>
              </Grid>
          }
          <Grid item>
            <Button color='secondary' onClick={() => setPath('root')}>
              Fechar
            </Button>
          </Grid>
        </>
    }
    </Grid>
  </Grid>;
};

export default Choose;
